<tec-modal [isVisible]="isVisible" [title]="'CONNECTIONS.WORK_LIFE.HELP.TITLE' | translate" (closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="'CONNECTIONS.WORK_LIFE.HELP.DESCRIPTION' | translate"></span>
        <pwcs-inline-svg src="assets/images/work-life-help.svg" idSuffix="modal-work-life-help" />
	</ng-container>
</tec-modal>
